<mat-card class="queue-card">
  <mat-card-header>
    <app-loader [status]="loaderStatus"></app-loader>
    <div mat-card-avatar class="queue-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">queue</mat-icon>
    </div>
    <mat-card-title> TMS - QUEUE</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table>
      <tr *ngFor="let queuecommand of queuecommandlist">
        <td>{{queuecommand.timestamp}}</td>
        <td>{{queuecommand.source }}</td>
        <td>{{queuecommand.codestring }}</td>
        <td>{{queuecommand.codebyte}}</td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
